import { render, staticRenderFns } from "./Stages.vue?vue&type=template&id=d54033f6"
import script from "./Stages.vue?vue&type=script&lang=js"
export * from "./Stages.vue?vue&type=script&lang=js"
import style0 from "./Stages.vue?vue&type=style&index=0&id=d54033f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports